import React from 'react';
import PropTypes from 'prop-types';
import { CTA } from 'modules/campaigns/config';
import EMPTY_FIELD_VALUE from 'modules/campaigns/modules/campaigns-reports/config/defaultValues';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

export const CTAValueCellRenderer = ({ value }) => {
    if (!value || !value.ctaType || value.ctaType === CTA.NONE) {
        return EMPTY_FIELD_VALUE;
    }

    const messageId = `creative.creator.content.cta.option.${value.ctaType}`;
    return <FormattedMessage id={messageId} defaultMessage={value.ctaType} />;
};

CTAValueCellRenderer.propTypes = {
    value: PropTypes.shape({
        ctaType: PropTypes.string,
    }),
};
